import styled from '@emotion/styled';

export const ServiceSettingsListContainer = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const ListItem = styled.div`
    background-color: #f8fafc;
    margin-bottom: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    width: 100%;
`;

export const ServiceSettingsHeader = styled.div`
    cursor: pointer;
    color: #111827;
    font-weight: 700;
    font-size: 0.9rem;
    line-height: 1.7;
    &::first-letter {
        text-transform: uppercase;
    }
`;
